import {
    AppTheme,
    AppThemeManager,
    customMessageBarColorsDark,
    customMessageBarColorsLight,
    legacyDarkNeutralColors,
    legacyNeutralColors,
    type AppColors,
    type CustomAppTheme,
} from 'owa-acui';
import { createTheme, type ITheme } from '@fluentui/react';
import { type Theme } from '@fluentui/react-components';
import { getPalette } from 'owa-theme';
import { getAppColors } from 'owa-acui-theme';

/** Sets the custom `AppTheme` definitions. */
export const setAppThemes = (themeV9: Theme): void => {
    const appThemeManager = AppThemeManager.getInstance();
    const v8Theme: ITheme = createTheme({ palette: getPalette() });

    const appColors = getAppColors();
    const legacyPrimaryColors = getLegacyPrimaryColors(appColors);

    const newThemeLight: CustomAppTheme = {
        ...customMessageBarColorsLight,
        ...legacyNeutralColors,
        ...legacyPrimaryColors,
        ...themeV9,
    };

    const newThemeDark: CustomAppTheme = {
        ...customMessageBarColorsDark,
        ...legacyDarkNeutralColors,
        ...legacyPrimaryColors,
        ...themeV9,
    };

    appThemeManager.setTheme(AppTheme.Light, v8Theme, newThemeLight);
    appThemeManager.setTheme(AppTheme.Dark, v8Theme, newThemeDark);
};

type LegacyPrimaryColors = Pick<
    CustomAppTheme,
    | 'legacy_themeDarker'
    | 'legacy_themeDark'
    | 'legacy_themeDarkAlt'
    | 'legacy_themePrimary'
    | 'legacy_themeSecondary'
    | 'legacy_themeTertiary'
    | 'legacy_themeLight'
    | 'legacy_themeLighter'
>;

const getLegacyPrimaryColors = (appColors: AppColors): LegacyPrimaryColors => {
    return {
        legacy_themeDark: appColors.shade20,
        legacy_themeDarkAlt: appColors.shade10,
        legacy_themeDarker: appColors.shade30,
        legacy_themeLight: appColors.tint30,
        legacy_themeLighter: appColors.tint40,
        legacy_themePrimary: appColors.primary,
        legacy_themeSecondary: appColors.tint10,
        legacy_themeTertiary: appColors.tint20,
    };
};
